import {
  useState,
  Fragment,
  useRef,
  useCallback,
} from 'react';
import TextInformation from '../../../../../../components/TextInformation/TextInformation';
import {
  BodyText,
  Row,
  SmallHeightDivider,
  MediumHeightDivider,
  StyledPagination,
  FairBodyText,
  SubTitle,
  StyledDownloadIcon,
  StyledLaunchIcon,
} from '../../../../../../theme/Styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import {
  CardPriceTitle,
  Container,
  PriceContainer,
  TextListContainer,
  TextOrderedListContainer,
  CardPriceGray,
  StyledFacebookIcon,
  StyledTwitterIcon,
  StyledEmailIcon,
  StyledPrintIcon,
  TopContainer,
  TopItemContainer,
  VariationsContainer,
  CommentsContainer,
  PaginationContainer,
} from './styles/ServiceDescriptionStyles';
import { useQuery } from 'react-query';
import {
  getServiceCommentsAndRating,
  getServiceDescription,
} from '../../../../../../api/ServiceDescription';

import {  Grid, Rating } from '@mui/material';
import {
  hourIn24To12hours,
  priceVariationToLaborableTime,
} from '../../../../../../utilities/functions/FormatterUtil';
import IconButton from '@mui/material/IconButton';
import { useReactToPrint } from 'react-to-print';
import CenterLoading from '../../../../../../components/CenterLoading/CenterLoading';
import Comment from '../../../../../../components/Comment/Comment';
import COLORS from '../../../../../../theme/Colors';
import { capitalizeFirstLetter } from '../../../../../../utilities/functions/StringUtil';

function ServiceDescription(props) {

  const serviceID = props.data.id;
  const matchesWidth = useMediaQuery('(min-width:768px)');
  const history = useHistory();
  const dispatch = useDispatch();
  const componentToPrintRef = useRef(null);

  const [loginOrRegisterModalStatus, setLoginOrRegisterModalStatus] = useState(false);
  const [currentCommentsPage, setCurrentCommentsPage] = useState(1);


  const { data: serviceDescription, isLoading } = useQuery(
    ['serviceDescription', serviceID],
    async () => {
      try {
        const response = await getServiceDescription(serviceID);
        return response;
      } catch (error) {
        history.push('/app/home');
      }
    }
  );

  const { data: serviceComments, isLoading: serviceCommentsIsLoading } =
    useQuery(['serviceComments', serviceID, currentCommentsPage], () =>
      getServiceCommentsAndRating(serviceID, currentCommentsPage)
    );

  const reactToPrintContent = useCallback(() => {
    return componentToPrintRef.current;
  }, [componentToPrintRef.current]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: serviceDescription?.name,
    pageStyle: 'width:400px',
    removeAfterPrint: true,
  });

  const handleChangePage = (page) => {
    setCurrentCommentsPage(page);
  };

  const handleServiceRequest = (serviceID) => {
    /* if (authenticated) {
       history.push(`/app/requestService/${serviceID}`);
     } else {
       setLoginOrRegisterModalStatus(!loginOrRegisterModalStatus);
     }
     */
  };

  if (isLoading || serviceCommentsIsLoading) return <CenterLoading />;

  return (
    <Container>

      <Container ref={componentToPrintRef} style={{ width: '100%' }}>
        <TopContainer>
          <TopItemContainer>
            <strong>
              <BodyText>Rating</BodyText>
            </strong>
            <Rating
              value={serviceDescription?.rating}
              precision={0.5}
              readOnly
              size='large'
            />
          </TopItemContainer>

          <TopItemContainer>
            <strong>
              <BodyText>Imprimir</BodyText>
            </strong>
            <IconButton onClick={handlePrint}>
              <StyledPrintIcon />
            </IconButton>
          </TopItemContainer>

          <TopItemContainer>
            <strong>
              <BodyText>Compartir</BodyText>
            </strong>
            <Row>
              <IconButton
                onClick={() =>
                  window.open(
                    `http://www.facebook.com/sharer.php?u=${window.location.href}`,
                    'name',
                    'width=600,height=400'
                  )
                }
              >
                <StyledFacebookIcon />
              </IconButton>

              <IconButton
                onClick={() =>
                  window.open(
                    `https://twitter.com/share?text=Ahora es mas facil solicitar trámites con la Ventanilla Única de Inversión😁&url=${window.location.href}&hashtags=VUI,PRODOMINICANA`,
                    'name',
                    'width=600,height=400'
                  )
                }
              >
                <StyledTwitterIcon />
              </IconButton>

              <IconButton
                onClick={() =>
                  window.open(
                    `mailto:?subject=Ahora es mas facil solicitar trámites con la Ventanilla Única de Inversión😁&body=${window.location.href}`
                  )
                }
              >
                <StyledEmailIcon />
              </IconButton>
            </Row>
          </TopItemContainer>
        </TopContainer>
        <SmallHeightDivider />

        <SubTitle>{serviceDescription?.name}</SubTitle>

        <SmallHeightDivider />
        <SmallHeightDivider />

        <TextInformation
          title='Institución'
          content={serviceDescription?.institution?.name}
          />

        <SmallHeightDivider />
        <SmallHeightDivider />

        <TextInformation
          title='Información general'
          content={serviceDescription?.description}
        />

        <SmallHeightDivider />
        <SmallHeightDivider />
        <TextInformation title='Requisitos' />
        <SmallHeightDivider />

        <TextListContainer>
          {
            serviceDescription?.requirements?.map((requeriment, index) => (
              <li key={index} style={{ marginTop: '5px' }}>
                <FairBodyText>
                  <strong>
                    {requeriment.name}
                  </strong>
                </FairBodyText>
                {requeriment.route &&
                    <Row>
                      <StyledDownloadIcon />
                      <FairBodyText onClick={() => window.open(requeriment.route, '_blank')} isUrl={true}>
                        Descargar archivo
                      </FairBodyText>
                    </Row>
                  }
                  {
                  requeriment?.external_link &&
                    <Row>
                      <StyledLaunchIcon />
                      <FairBodyText onClick={() => window.open(requeriment.external_link, '_blank')} isUrl={true}>
                        Abrir en nueva pestaña
                      </FairBodyText>
                    </Row>
                  }
                <FairBodyText>
                  {requeriment?.description}
                </FairBodyText>
              </li>
            ))
          }
        </TextListContainer>

        <SmallHeightDivider />
        <SmallHeightDivider />

        <TextInformation title='Procedimiento' />
        <SmallHeightDivider />
        <TextOrderedListContainer>
          {serviceDescription?.procedures.map((requeriment, index) => (
            <li key={index} style={{ marginTop: '5px' }}>
              <BodyText>{requeriment.step}</BodyText>
            </li>
          ))}
        </TextOrderedListContainer>

        <SmallHeightDivider />
        <SmallHeightDivider />

        <TextInformation title='Tarifa del servicio' />
        <SmallHeightDivider />

        <Grid
          alignItems='center'
          container
          direction='row'
          justifyContent='center'
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          {serviceDescription?.prices.map((price, index) => (
            <Grid item xs={4} sm={8} md={12} key={index}>
              <PriceContainer>
                <strong>
                  <CardPriceTitle>{price.concept}</CardPriceTitle>
                </strong>
                <CardPriceTitle>{price.description}</CardPriceTitle>
                <SmallHeightDivider />
                <VariationsContainer>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <strong>
                      <CardPriceGray>Variaciones de la tarifa</CardPriceGray>
                    </strong>
                    <br />
                    {price.variations.map((variation) => (
                      <strong>
                        <BodyText>{variation.concept}</BodyText>
                      </strong>
                    ))}
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <strong>
                      <CardPriceGray>Tiempo de entrega</CardPriceGray>
                    </strong>
                    <br />
                    {price.variations.map((variation) => (
                      <strong>
                        <BodyText>
                          {priceVariationToLaborableTime(
                            variation.delivery_time
                          )}
                        </BodyText>
                      </strong>
                    ))}
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <strong>
                      <CardPriceGray>Tarifa</CardPriceGray>
                    </strong>
                    <br />
                    {price.variations.map((variations) => (
                      <strong>
                        <BodyText>
                          DOP
                          {Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD',
                          }).format(variations.price)}
                        </BodyText>
                      </strong>
                    ))}
                  </div>
                </VariationsContainer>
              </PriceContainer>
            </Grid>
          ))}
        </Grid>
        <SmallHeightDivider />
        <SmallHeightDivider />

        <TextInformation
          title='Horario de prestación de servicio'
          content={
            'Las solicitudes podrán ser realizadas 24hrs los 7 días de la semana, pero estas serán trabajadas por la institución en horario laborable.'
          }
        />
        <SmallHeightDivider />

        <Row style={{ justifyContent: 'space-between', width: '100%' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <strong>
              <CardPriceGray>Día</CardPriceGray>
            </strong>
            <br />
            {serviceDescription?.schedules.map((schedule, index) => (
              <strong>
                <BodyText>{schedule.day}</BodyText>
              </strong>
            ))}
          </div>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <strong>
              <CardPriceGray>Desde</CardPriceGray>
            </strong>
            <br />
            {serviceDescription?.schedules.map((schedule, index) => (
              <strong>
                <BodyText>{hourIn24To12hours(schedule.init)}</BodyText>
              </strong>
            ))}
          </div>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <strong>
              <CardPriceGray>Hasta</CardPriceGray>
            </strong>
            <br />
            {serviceDescription?.schedules.map((schedule, index) => (
              <strong>
                <BodyText>{hourIn24To12hours(schedule.finit)}</BodyText>
              </strong>
            ))}
          </div>
        </Row>

        <SmallHeightDivider />
        <SmallHeightDivider />
        <CommentsContainer>
          <TextInformation title='Comentarios' />
          <SmallHeightDivider />
          {serviceComments.data.map((comment, index) => (
            <Fragment key={index}>
              <Comment
                key={index}
                userName={`${comment.citizen.name} ${comment.citizen.surname}`}
                comment={comment.comment}
                date={comment.created_at}
                rating={comment.rating}
              />
              <SmallHeightDivider />
            </Fragment>
          ))}

          {serviceComments.data.length > 0 ? (
            <PaginationContainer>
              <StyledPagination
                count={serviceComments?.last_page}
                page={currentCommentsPage}
                onChange={(event, page) => {
                  handleChangePage(page);
                }}
                variant='outlined'
                shape='rounded'
                sx={{ color: COLORS.primary }}
              />
              <SmallHeightDivider />
            </PaginationContainer>
          ) : (
            <strong>
              <BodyText>No hay comentarios para este servicio.</BodyText>
            </strong>
          )}
        </CommentsContainer>
      </Container>
      <MediumHeightDivider />
    </Container>
  );
}

export default ServiceDescription;
